import React, {useEffect, useState} from 'react'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import firebase from 'firebase'
import './Profile.css'

export const ShowProfile = (props) => {
	let [about, setAbout] = useState('')
	let [imageURL, setImageURL] = useState('')

	const getProfile = () => {
		if (firebase.auth().currentUser) {
			firebase.database()
				.ref("users/" + firebase.auth().currentUser.uid)
				.once("value")
				.then((snapshot) => {
					const aboutText = (snapshot.val() && snapshot.val().About)
					const profile_url = (snapshot.val() && snapshot.val().profile_photo)
					setImageURL(profile_url)
					setAbout(aboutText)
				})
		}
	}

	useEffect(() => {
		getProfile();
	})

	return (
		<Grid container xs={12}>
			<Grid xs={12}>
				{/* <AppBar position="static">
					<Toolbar classes={{root: {backgroundColor: '#4f6e12'}}}>
						<h1>Profile Page</h1>
					</Toolbar>
				</AppBar> */}
			</Grid>
			<br/><br/>
			<Grid item xs={12}>
				<Box display="flex">
					<Card>
						<CardContent>
							<div>
							{imageURL ? (
								<img className="profileImage" src={imageURL}/>) :
								(<div className="emptyImage">Profile Photo Here</div>)}
							</div>
							<div>
								<span className="aboutMe">About Me:</span>
								<p>{about}</p>
							</div>
							<br/>
						</CardContent>
						<Button className="editButton" onClick={() => props.setEditProfile(true) }>Edit Profile</Button>
					</Card>

				</Box>
			</Grid>
		</Grid>

	)
}

export default ShowProfile;
